module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form",
    attrs: {
      "id": "tripMng"
    }
  }, [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('el-row', {
    staticStyle: {
      "line-height": "36px"
    }
  }, [_c('span', {
    staticClass: "el-col el-col-8"
  }, [_vm._v(_vm._s(_vm.$t('ROUTETRIP')) + " "), _c('b', [_vm._v(_vm._s(_vm.tripDate(_vm.trip.Db_Date)))])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading_stops),
      expression: "loading_stops"
    }],
    staticClass: "box-card",
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "element-loading-text": _vm.$t('LOADING'),
      "body-style": {
        padding: 0,
        height: _vm.cardHeight + 'px'
      }
    }
  }, [_c('VuePerfectScrollbar', {
    ref: "Scrollbar",
    staticClass: "scrollbar",
    style: ({
      height: _vm.tabHeight + 'px'
    })
  }, [_c('el-row', [_c('el-steps', {
    attrs: {
      "space": 200,
      "direction": "vertical",
      "active": 1
    }
  }, _vm._l((_vm.stops), function(stop, key) {
    return _c('div', {
      key: key,
      staticClass: "el-step is-vertical",
      staticStyle: {
        "margin-right": "0px",
        "min-height": "50px"
      }
    }, [_c('div', {
      staticClass: "el-step__head is-finish is-text"
    }, [_c('div', {
      staticClass: "el-step__line is-vertical",
      staticStyle: {
        "margin-right": "0px"
      }
    }, [_c('i', {
      staticClass: "el-step__line-inner",
      staticStyle: {
        "transition-delay": "0ms",
        "height": "100%"
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "el-step__icon"
    }, [(key !== 0) ? _c('div', {
      domProps: {
        "textContent": _vm._s(key)
      }
    }) : _vm._e(), _vm._v(" "), (key === 0) ? _c('div', [_c('i', {
      staticClass: "fa fa-bus"
    })]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "el-step__main"
    }, [_c('div', {
      staticClass: "el-step__title is-finish"
    }, [_c('span', {
      domProps: {
        "textContent": _vm._s(key !== 0 ? _vm.$t('STOP') : _vm.$t('TO') + ' ' + (_vm.trip.Direction == 1 ? _vm.$t('SCHOOL') : _vm.$t('HOME')))
      }
    }), _vm._v(" "), (key !== 0) ? _c('span', {
      domProps: {
        "textContent": _vm._s(key)
      }
    }) : _vm._e(), _vm._v(" "), (key == 0) ? _c('div', {
      staticClass: "pull-right"
    }, [(_vm.trip.Db_Date != null) ? _c('el-row', [_c('span', {
      staticStyle: {
        "font-weight": "400"
      },
      domProps: {
        "textContent": _vm._s(_vm.$t('STARTEDAT') + ':')
      }
    }), _vm._v(" " + _vm._s(_vm.unixConverter(_vm.trip.timestamp)))]) : _vm._e(), _vm._v(" "), (_vm.trip.IsClosed == 1) ? _c('el-row', [_c('span', {
      staticStyle: {
        "font-weight": "400"
      },
      domProps: {
        "textContent": _vm._s(_vm.$t('CLOSEDAT') + ':')
      }
    }), _vm._v(" " + _vm._s(_vm.unixConverter(_vm.trip.UpdatedAt)))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (key !== 0) ? _c('el-card', {
      staticClass: "box-card students",
      attrs: {
        "body-style": {
          padding: '0px'
        }
      }
    }, [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('small', [_vm._v(_vm._s(_vm.$t('ESTIMATEDARRIVALTIME')) + " "), _c('span', {
      domProps: {
        "textContent": _vm._s(stop.DeltaT)
      }
    }), _vm._v(" " + _vm._s(_vm.$t('MIN')))])]), _vm._v(" "), _vm._l((stop.student), function(student, index) {
      return (key !== 0) ? _c('el-row', {
        key: index,
        staticClass: "list",
        style: ({
          'background-color': [(student.IsAbsent) ? '#CCCCCC' : 'unset']
        })
      }, [_c('span', [_c('i', {
        staticClass: "fa fa-wifi fa-rotate-270 fa-2x",
        class: _vm.tagIcon(student)
      })]), _vm._v(" "), _c('img', {
        staticClass: "img-circle",
        staticStyle: {
          "width": "50px"
        },
        attrs: {
          "src": _vm.getAsset(student.ImagePath, 'student')
        }
      }), _vm._v("\n                          " + _vm._s(_vm._FullName({
        NameEN: student.FullName_EN,
        NameAR: student.FullName_AR
      })) + "             \n                          "), _c('el-button-group', {
        staticClass: "turn"
      }, [(student.CheckIn) ? _c('el-tooltip', {
        attrs: {
          "content": _vm.$t('CHECKEDINAT') + ' ' + _vm.tripTime(student.CheckIn),
          "placement": "top"
        }
      }, [_c('el-button', {
        attrs: {
          "type": "success",
          "icon": "arrow-up",
          "size": "mini"
        }
      }, [_vm._v(_vm._s(_vm.tripTime(student.CheckIn)))])], 1) : _vm._e(), _vm._v(" "), (student.IsMissing) ? _c('el-tooltip', {
        attrs: {
          "content": _vm.$t('ABSENTAT') + ' ' + _vm.tripTime(student.IsMissing),
          "placement": "top"
        }
      }, [_c('el-button', {
        attrs: {
          "type": "danger",
          "icon": "warning",
          "size": "mini"
        }
      }, [_vm._v(_vm._s(_vm.tripTime(student.IsMissing)))])], 1) : _vm._e(), _vm._v(" "), (student.CheckOut) ? _c('el-tooltip', {
        attrs: {
          "content": _vm.$t('CHECKEDOUTAT') + ' ' + _vm.tripTime(student.CheckOut),
          "placement": "top"
        }
      }, [_c('el-button', {
        attrs: {
          "type": "warning",
          "icon": "arrow-down",
          "size": "mini"
        }
      }, [_vm._v(_vm._s(_vm.tripTime(student.CheckOut)))])], 1) : _vm._e(), _vm._v(" "), (student.IsAbsent) ? _c('el-tooltip', {
        attrs: {
          "content": _vm.$t('REPORTEDBY') + ' ' + student.IsAbsent.ReportedBy,
          "placement": "top"
        }
      }, [_c('el-button', {
        attrs: {
          "type": "danger",
          "icon": "warning",
          "size": "mini"
        }
      }, [_vm._v(_vm._s(_vm.$t('ABSENT')))])], 1) : _vm._e()], 1)], 1) : _vm._e()
    }), _vm._v(" "), (stop.student.length === 0 && key !== 0) ? _c('el-row', {
      staticStyle: {
        "padding": "10px",
        "background-color": "rgb(209, 219, 229)",
        "color": "#4b4b4b"
      }
    }, [_c('el-col', {
      attrs: {
        "align": "center"
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.$t('NOSTUDENTSADDEDTOTHISSTOP')))])])], 1) : _vm._e(), _vm._v(" "), _c('el-row', {
      staticClass: "only-top-border"
    })], 2) : _vm._e()], 1)])])
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "span": 16,
      "element-loading-text": _vm.$t('LOADING')
    }
  }, [_c('el-tabs', {
    staticClass: "formTab",
    style: ({
      height: _vm.cardHeight + 'px'
    }),
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": function($event) {
        _vm.getExpense()
      }
    }
  }, [_c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-map"
  }), _vm._v(" " + _vm._s(_vm.$t('Map')))]), _vm._v(" "), _c('el-card', {
    staticStyle: {
      "border-top": "0",
      "border-bottom": "0"
    },
    attrs: {
      "clasExpenditures": "bordred-card",
      "body-style": {
        padding: 0,
        height: _vm.cardHeight + 'px'
      }
    }
  }, [_c('el-row', {
    ref: "staff",
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "border1",
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "fa fa-road fa-3x"
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('ROUTE')))]), _c('br'), _vm._v(" "), _c('el-tag', {
    style: ('background-color:' + _vm.route.RouteColor)
  }, [_vm._v("# " + _vm._s(_vm.trip.TourName))])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "border2",
    attrs: {
      "span": 8
    }
  }, [_c('img', {
    staticClass: "img-circle",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": _vm.getAsset(_vm.monitor.ImagePath, 'supervisor')
    }
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('SUPERVISOR')))]), _c('br'), _vm._v("\n                    " + _vm._s(_vm._FullName({
    NameEN: _vm.monitor.FullName_EN,
    NameAR: _vm.monitor.FullName_AR
  })) + "\n                ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('img', {
    staticClass: "img-circle",
    staticStyle: {
      "width": "50px"
    },
    attrs: {
      "src": _vm.getAsset(_vm.driver.ImagePath, 'driver')
    }
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('DRIVER')))]), _c('br'), _vm._v("\n                    " + _vm._s(_vm._FullName({
    NameEN: _vm.driver.FullName_EN,
    NameAR: _vm.driver.FullName_AR
  })) + "\n                ")])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "position": "relative",
      "border-top": "1px solid rgb(209, 219, 229)"
    },
    style: ({
      height: _vm.mapHeight + 'px'
    }),
    attrs: {
      "id": "trip-gmap-live"
    }
  }), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCost(_vm.trip)),
      expression: "showCost(trip)"
    }],
    ref: "cost",
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticClass: "border1",
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "fa fa-money fa-3x"
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('FUELCOST')))]), _c('br'), _vm._v(" "), _c('el-tag', [_vm._v(_vm._s(_vm.trip.TravelCost + ' ' + _vm.$t('AED')) + " ")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "border1",
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "fa fa-money fa-3x"
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('IDLECOST')))]), _c('br'), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "danger"
    }
  }, [_vm._v(_vm._s(_vm.trip.IdleCost + ' ' + _vm.$t('AED')) + " ")])], 1), _vm._v(" "), _c('el-col', {
    staticClass: "border1",
    attrs: {
      "span": 8
    }
  }, [_c('i', {
    staticClass: "fa fa-money fa-3x"
  }), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('TOTALCOST')))]), _c('br'), _vm._v(" "), _c('el-tag', [_vm._v(_vm._s(_vm.trip.TotalCost + ' ' + _vm.$t('AED')) + " ")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.showCost(_vm.trip)) ? _c('el-tab-pane', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" " + _vm._s(_vm.$t('EXPENDITURE')))]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "20px",
      "padding-bottom": "0",
      "font-size": "14px"
    }
  }, [_c('span', {
    staticClass: "el-col el-col-6"
  }, [_vm._v(_vm._s(_vm.$t('TRIPDISTANCE')) + " "), _c('b', [_vm._v(_vm._s(_vm.distance + ' ' + 'km'))])]), _vm._v(" "), _c('span', {
    staticClass: "el-col el-col-6"
  }, [_vm._v(_vm._s(_vm.$t('TRIPIDLING')) + " "), _c('b', [_vm._v(_vm._s(_vm.idlingTime + ' ' + 'mins'))])]), _vm._v(" "), _c('span', {
    staticClass: "el-col el-col-6"
  }, [_vm._v(_vm._s(_vm.$t('COMPLETEDTRIPS')) + " "), _c('b', [_vm._v(_vm._s(_vm.expense.doneTrips))])])]), _vm._v(" "), _c('el-row', {
    staticClass: "tab-table-margin",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.listExpenses,
      "highlight-current-row": "",
      "height": 620,
      "stripe": "",
      "show-summary": "",
      "summary-method": _vm.getSummaries
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('FACTORS'),
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm.$t(scope.row.label)) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('COST'),
      "prop": "cost"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm.$t(scope.row.cost)) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('TIME')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          class: [scope.row.time ? 'el-icon-time' : '']
        }), _vm._v("\n                  " + _vm._s(_vm.$t(scope.row.time)) + "\n                ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('FORMULA'),
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', [_vm._v(_vm._s(_vm.$t(scope.row.calc)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('RESULT'),
      "prop": "result"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                  " + _vm._s(_vm.$t(scope.row.result)) + "\n                ")]
      }
    }])
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f241c74a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/TripManage.vue
// module id = 629
// module chunks = 1